import axios from 'axios'

const HOST = process.env.REACT_APP_API_HOST || 'https://api.blackburndefense.com'

async function makeRequest (method, url, getAccessTokenSilently, data) {
  console.log(method, url, getAccessTokenSilently, data)
  const token = await getAccessTokenSilently({
    authorizationParams: {
      audience: 'https://dev-f0as8l0dh5rc8lfa.us.auth0.com/api/v2/',
    }
  })
  const response = await axios({
    method,
    url: `${HOST}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
  return response
}

export function getData (id, getAccessTokenSilently) {
  return makeRequest('get', `/api/data/${id}`, getAccessTokenSilently)
}

export function saveData (id, data, getAccessTokenSilently) {
  return makeRequest('post', `/api/data/${id}`, getAccessTokenSilently, data)
}

export function getAllData (getAccessTokenSilently) {
  return makeRequest('get', '/api/data', getAccessTokenSilently)
}

export function deleteData (id, getAccessTokenSilently) {
  return makeRequest('delete', `/api/data/${id}`, getAccessTokenSilently)
}
